import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ImageUpload from "src/Components/GlobalComponents/ImageUplaod";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import httpRequest from "src/helpers/httpRequest";
import { IHomePageInterface } from "src/types/GlobalInterfaces";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { canWrite, convertToKebabCase } from "src/helpers/helperFunctions";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
interface IProps {
  allCategories: { value: string; label: string }[];
  getLoader: boolean;
  sectionTitle: string;
  apiEndPoint: string;
  data: { banner: string; mainCategoryId: string };
  allList: string[];
  setData: React.Dispatch<React.SetStateAction<IHomePageInterface | null>>;
  keys: "sectionThree" | "sectionFour" | "sectionFive" | "sectionSix";
  mainHeading?: string;
  serviceTitle?: string;
  isHomeCare?: boolean;
}

const CategoriesBanners: React.FC<IProps> = ({
  allCategories = [],
  getLoader = false,
  sectionTitle,
  apiEndPoint,
  data,
  allList,
  setData,
  keys,
  mainHeading = "Pharmacy Banner",
  serviceTitle = "Select Pharma Category",
  isHomeCare = false,
}) => {
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const hasWriteAccess = canWrite(userDetails, "platformManagement", false);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [categoryBanner, setCategoryBanner] = useState<File | null | string>(
    null
  );
  const [mainCategory, setMainCategory] = useState<string>("");

  const handleSubmit = async () => {
    if (!categoryBanner || !mainCategory) {
      if (!categoryBanner) {
        toast("Banner is required.", { type: "error" });
      }
      if (!mainCategory) {
        toast("Category is required.", { type: "error" });
      }
      return;
    } else {
      setIsLoader(true);
      const formData = new FormData();
      if (categoryBanner) {
        formData.append(isHomeCare ? "homeCareBanner" : "banner", categoryBanner);
      }
      formData.append(isHomeCare ? "homeCareCategoryId" : "mainCategoryId", mainCategory);
      const { res, err } = await httpRequest<{
        _id: string;
        categoryBanner: string;
        mainCategoryId: string;
      }>({
        method: "put",
        path: apiEndPoint,
        params: formData,
        header: { "Content-Type": "multipart/form-data" },
      });
      if (res) {
        toast(isHomeCare ? "Homecare Banner Updated" : "Categories Updated", { type: "success" });
      } else {
        toast(err, { type: "error" });
      }
      setIsLoader(false);
    }
  };

  useEffect(() => {
    if (data) {
      setCategoryBanner(data?.banner);
      setMainCategory(data?.mainCategoryId);
    }
  }, [data]);

  return (
    <div className="section__2">
      <h1 className="font-Poppins-SemiBold font-size-25px mb-2 theme-color-green">
        {sectionTitle}
      </h1>
      <div className="products-tabs-content">
        <h3 className="font-size-18px text-[#2F2F31] mb-3 font-Poppins-Regular">
          {mainHeading}
        </h3>
        <div className="grid grid-cols-2">
          <div className="col-span-2">
            <ImageUpload
              newUi={true}
              image={categoryBanner}
              onImageChange={setCategoryBanner}
              extraClasses={"w-full min-h-[340px]"}
              labelId={`${convertToKebabCase(sectionTitle || "")}-banner`}
              disabled={!hasWriteAccess}
            />
          </div>
          <div className="col-span-2 md:col-span-1">
            <CustomWebsiteDropdown
              loading={getLoader}
              options={allCategories.map((v) => ({
                ...v,
                disabled: allList.some((prev) => prev === v.value),
              }))}
              data={allCategories.filter((v) => v?.value === mainCategory)}
              setData={(e) => setMainCategory(e[0]?.value || "")}
              placeholder="Select Category"
              dropdownMainId={`${convertToKebabCase(sectionTitle || "")}-dropdown`}
              disabled={!hasWriteAccess}
            />
          </div>
        </div>
      </div>
      <div className="flex justify-end mt-3">
        <PrimaryBtn
          loader={isLoader}
          ButtonText="Save"
          btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
          // onPress={handleSubmit}
          onPress={() => {
            if (!hasWriteAccess) {
              return;
            }
            handleSubmit();
          }}
          btnExtralClasses={`${!hasWriteAccess ? "cursor-not-allowed" : ""}`}
          id={`${convertToKebabCase(sectionTitle || "")}-save`}
          disabled={!hasWriteAccess}
        />
      </div>
    </div>
  );
};

export default CategoriesBanners;
